import { render } from "./TheNavbar.vue?vue&type=template&id=3ae5d334"
const script = {}

import "./TheNavbar.vue?vue&type=style&index=0&id=3ae5d334&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__